import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=1011b54e&scoped=true"
import script from "./NewCompany.vue?vue&type=script&lang=js"
export * from "./NewCompany.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NewCompany.vue?vue&type=style&index=1&id=1011b54e&prod&scoped=true&lang=css"
import style2 from "./NewCompany.vue?vue&type=style&index=2&id=1011b54e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011b54e",
  null
  
)

export default component.exports